import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface CpState {
  cp: string;
}

const initialState: CpState = {
  cp: "",
};

export const cpSlice = createSlice({
  name: 'codigo-postal',
  initialState,
  reducers: {
    updateCp: (state, action: PayloadAction<string>) => {
      state.cp = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateCp,
} = cpSlice.actions;

export default cpSlice.reducer;
